// ATTENTION: À chaque modification du fichier .ts, il faut lancer:
// npx tsc src/domains/paniers/panier.ts
// Les erreurs ne sont pas problématiques, le fichier est quand même transpilé

import Liste from "@/domains/listes/liste";

// ---------------------------- ICI c'est le No Man's Land ----------------------------
// -----------------------------------------------------------------------------------

export default class Panier extends Liste {
}
